import { c as _c } from "react/compiler-runtime";
import Link from '@/components/elements/Link';
import { ENV, ESTABLISHMENT_EMAIL, ESTABLISHMENT_NAME, ESTABLISHMENT_PHONE, LOCALE } from '@/constants/config';
import translator from '@/contexts/i18nContext/translator';
import { isDev as isDev_ } from '@winelidays/wld-tsx-2/utils';
import { ERROR_PAGE_TRANSLATIONS } from './const';
const isDev = isDev_(ENV);
const getText = ({ key, translate }) => {
    const translation = translate(`error.widget.global_error.${key}`);
    if (!translation || translation.includes(key)) {
        const translations = LOCALE in ERROR_PAGE_TRANSLATIONS ?
            ERROR_PAGE_TRANSLATIONS[LOCALE] :
            ERROR_PAGE_TRANSLATIONS.en;
        return translations[key];
    }
    return translation;
};
const ErrorPage = (t0) => {
    const $ = _c(8);
    const { error, componentStack } = t0;
    const translate = _temp;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = getText({ key: "title", translate });
        $[0] = t1;
    }
    else {
        t1 = $[0];
    }
    const title = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = getText({ key: "description", translate });
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const description = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <div>
      <h1 className="font-bold text-2xl mb-6">{title}</h1>
      <p className="font-semibold text-gray-400">{description}</p>
      {ESTABLISHMENT_EMAIL || ESTABLISHMENT_PHONE ?
                <div className="my-6 flex flex-col items-center">
        <p className="text-center font-semibold p-4 rounded border border-gray-100 min-w-72">
          {ESTABLISHMENT_NAME ?
                        <span className="block text-gray-700 mb-2 last:mb-0">{ESTABLISHMENT_NAME}</span> : null}
          {ESTABLISHMENT_EMAIL ?
                        <Link className="block text-primary mb-2 last:mb-0" externalLink={true} href={`mailto:${ESTABLISHMENT_EMAIL}`}>

            {ESTABLISHMENT_EMAIL}
          </Link> : null}
          {ESTABLISHMENT_PHONE ?
                        <Link className="block text-primary mb-2 last:mb-0" externalLink={true} href={`tel:${ESTABLISHMENT_PHONE}`}>

            {ESTABLISHMENT_PHONE}
          </Link> : null}
        </p>
      </div> : null}
    </div>;
        $[2] = t3;
    }
    else {
        t3 = $[2];
    }
    let t4;
    if ($[3] !== componentStack || $[4] !== error) {
        t4 = isDev &&
            <div className="w-full flex flex-col mt-6">
      <pre>{JSON.stringify(error)}</pre>
      {componentStack ? <pre>{componentStack}</pre> : null}
    </div>;
        $[3] = componentStack;
        $[4] = error;
        $[5] = t4;
    }
    else {
        t4 = $[5];
    }
    let t5;
    if ($[6] !== t4) {
        t5 = <div className="w-full min-h-100 flex flex-col justify-center py-10">{t3}{t4}
    </div>;
        $[6] = t4;
        $[7] = t5;
    }
    else {
        t5 = $[7];
    }
    return t5;
};
export default ErrorPage;
function _temp(key, t0) { const variables = t0 === undefined ? {} : t0; const tag = key.split(".")[0]; return translator.trans(key, variables, tag, LOCALE); }
